// Add pills to pills area in form actions
const addPill = (text, id, formId) => {
  const pills = document.querySelector(`#${formId} .pills`)
    ? document.querySelector(`#${formId} .pills`)
    : document.querySelector(`.keywords--pills .pills`);
  const placeholder = pills.querySelector("span");
  if (placeholder) placeholder.remove();
  pills.innerHTML += `<div class="d-flex align-items-center px-2 pill" data-target="${id}">${text}</pill>`;
  return pills.querySelector(`[data-target="${id}"]`);
};

module.exports = {
  addPill,
};
